module.exports = __webpack_public_path__ + "static/media/lk.578f045c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/lk.png
// module id = 1908
// module chunks = 0